export default {
  HANDLE_REGISTER_ERROR: 'handleRegisterError',
  HANDLE_GET_COUNTRIES: 'handleGetCountries',
  HANDLE_CHECK_USER_EXIST: 'handleCheckUserExist',
  TOGGLE_REGISTER_TYPE_MODAL: 'toggleRegisterTypeModal',
};



// WEBPACK FOOTER //
// ./src/app/main/register/constants/action-types.js